<div class="h-full w-full" id="{{'map-' + voyageCode}}" #mapContainer></div>
